import React, { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-form-validator-core";
import Header from "../layout/Header";
import SelectValidator from "../partial/SelectValidator";
import TextValidator from "../partial/TextValidator";
import TextAreaValidator from "../partial/TextAreaValidator";
import { getDropdownObject } from "../../utils/helper";
import {
  createEvent,
  customerGroupCounts,
  getEventItemsList,
} from "../pages/campaigns/services";
import { Link, useNavigate } from "react-router-dom";
import { backIcon2 } from "../../Image/Index";
import QueryBuilder, {
  defaultControlElements,
  formatQuery,
  fieldSelector,
} from "react-querybuilder";
import { decrypt } from "../../utils/encodingdecoding";
import { getCustomer } from "../../actions/schema";
import { getCustomerGroupList } from "../../actions/campaigns";
import CustomFieldSelector from "./CustomFieldSelector";
import CustomOperatorSelector from "./CustomOperatorSelector";
import CustomValueEditor from "./CustomValueEditor";

function CreateEvent() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    name: "",
    eventType: "",
    transactionType: "Pre",
    status: false,
    description: "",
    incomingRule: {
      incomingInfixRule: [],
      incomingPrefixRule: [],
    },
  });
  const {
    name,
    eventType,
    transactionType,
    status,
    description,
    incomingRule,
  } = state;
  const [eventTypeOpt, setEventTypeOpt] = useState([]);

  const initialQuery = {
    combinator: "and",
    rules: [],
  };
  const [query, setQuery] = useState(initialQuery);
  const [queryData, setQueryData] = useState({});
  const [data, setData] = useState([]);

  const [transTypeDisplay] = useState([
    { value: "Pre", label: "Pre" },
    { value: "Post", label: "Post" },
  ]);
  useEffect(() => {
    const querys = JSON.stringify(query, null, 2);
    setQueryData(querys);
  }, [query]);

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (Array.isArray(data) && data?.length) {
    }
  }, [data]);

  const fetch = async () => {
    try {
      setLoader(true);
      const token = JSON.parse(localStorage.getItem("token_gen"));
      const schemaRes = await getCustomer(token?.access_token);
      const customerGroupRes = await getCustomerGroupList(token?.access_token);
      const eventList = await getEventItemsList(token?.access_token);
      if (eventList.message === "Request processed successfully.") {
        if (eventList?.data?.eventItemsList?.length > 0) {
          setEventTypeOpt(() =>
            eventList?.data?.eventItemsList.map((ele) => {
              return {
                value: ele,
                label: ele,
              };
            })
          );
          setState((prev) => ({
            ...prev,
            eventType: eventList?.data?.eventItemsList[0],
          }));
        }
      }

      const customerOption = Object.entries(schemaRes.schema.properties)
        .filter(([key, property]) => {
          return property.StringTypeValidation?.[0]?.StringFormat !== "date";
        })
        .map(([key, property]) => ({
          key,
          fielddisplayname: property.fielddisplayname,
          type: property.fielddatatype,
          category: "Customer",
        }));

      const currentDateOption = Object.entries(schemaRes.schema.properties)
        .filter(([key, property]) => {
          return (
            property.fielddatatype === "String" &&
            property.StringTypeValidation?.[0]?.StringFormat === "date"
          );
        })
        .map(([key, property]) => ({
          key,
          fielddisplayname: property.fielddisplayname,
          type: property.fielddatatype,
          category: "Current Date",
        }));

      const groupOption = customerGroupRes?.data?.map((val) => ({
        fielddisplayname: val.customerGroupName,
        key: val.customerGroupName,
        category: "CustomerGroup",
      }));

      setData([
        ...(Array.isArray(customerOption) && customerOption.length
          ? customerOption
          : []),
        ...(Array.isArray(currentDateOption) && currentDateOption.length
          ? currentDateOption
          : []),
        ...(Array.isArray(groupOption) && groupOption.length
          ? groupOption
          : []),
      ]);

      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const fetchCustomerGroupCounts = async (groupname) => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const merchantCode = localStorage.getItem("Id");
    const res = await customerGroupCounts(
      token?.access_token,
      groupname,
      merchantCode
    );
    setLoader(false);
    return res?.data?.customerCount;
  };

  const onChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onSelectChange = (e, name) => {
    setState((prev) => ({
      ...prev,
      [name]: e.value,
    }));
  };

  const handleToggle = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };

  let fields = useMemo(() => {
    return data?.map((item) => {
      if (item?.category === "Current Date") {
        return {
          name: item?.key,
          label: item?.fielddisplayname,
          type: item?.type,
          valueEditorType: "select",
          values: [
            { value: "", label: "Select", key: "select-option" },
            { value: "Current_Date", label: "Current_Date" },
          ],
          category: item.category,
        };
      } else if (item?.category === "CustomerGroup") {
        return {
          name: item?.key,
          label: item?.fielddisplayname,
          type: item?.type,
          category: item.category,
          value: item.value,
        };
      } else {
        return {
          name: item?.key,
          label: item?.fielddisplayname,
          type: item?.type,
          category: item.category,
        };
      }
    });
  }, [data]);

  function manipulatePrefixRule(newQuery) {
    const transformRules = (rules) => {
      return rules?.map((rule) => {
        if (rule.rules) {
          return {
            rules: transformRules(rule.rules),
          };
        } else {
          let tempType, dataClass;
          fields?.filter((f) => {
            if (f.name === rule.field) {
              tempType = f.type;
              dataClass = f.category;
            }
          });
          return {
            id: rule.field,
            field: rule.field,
            type: tempType,
            input: tempType === ("string" || "boolean") ? "text" : "integer",
            operator: rule.operator,
            value: rule.value,
            data: {
              class: dataClass,
            },
          };
        }
      });
    };

    return {
      ...newQuery,
      valid: true,
      rules: transformRules(newQuery.rules),
    };
  }

  function manipulateInfixRule(newQuery) {
    const transformRules = (rules) => {
      return rules?.map((rule) => {
        if (rule.rules) {
          return {
            rules: transformRules(rule.rules),
          };
        } else {
          let tempType, dataClass;
          fields?.filter((f) => {
            if (f.name === rule.field) {
              tempType = f.type;
              dataClass = f.category;
            }
          });
          return {
            entityName: rule.field,
            field: rule.field,
            jsonPath:
              rule.operator === "between"
                ? `$.${rule.value}[?(@.${rule.field}>=${rule.value} && @.${rule.field} <=${rule.value1})]`
                : `$.${rule.field}[?(@.${rule.field}${rule.operator}${
                    rule.value ? rule.value : "0"
                  })]`,
            op: rule.operator,
            value: [rule.value],
            type: tempType === ("string" || "boolean") ? "text" : "integer",
            format: null,
          };
        }
      });
    };

    return transformRules(newQuery.rules);
  }

  const handleQueryChange = async (newQuery) => {
    let updatedFields = fields;

    if (newQuery.rules.length > 0) {
      const selectedFieldNames = newQuery.rules.map((rule) => rule.field);

      updatedFields = await Promise.all(
        fields.map(async (field) => {
          if (
            selectedFieldNames.includes(field.name) &&
            field?.category === "CustomerGroup"
          ) {
            try {
              const res = await fetchCustomerGroupCounts(field.name);
              return {
                ...field,
                value: res,
                valueEditorType: "text",
                key: field.name,
                fielddisplayname: field.label,
                type: field.type,
              };
            } catch (err) {
              return {
                ...field,
                key: field.name,
                fielddisplayname: field.label,
                type: field.type,
              };
            }
          }
          return {
            ...field,
            key: field.name,
            fielddisplayname: field.label,
            type: field.type,
          };
        })
      );
      setData(updatedFields);
    }
    setQuery(newQuery);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    let sqlWhere, tempPrefixRule, tempInfixRule, infix, rulesAsObject;
    if (query.rules?.length) {
      sqlWhere = formatQuery(query, "sql");
      tempPrefixRule = manipulatePrefixRule(query);
      tempInfixRule = manipulateInfixRule(query);
      infix = formatQuery(tempPrefixRule, "sql");
      rulesAsObject = JSON.parse(queryData);
    }

    const body = {
      event: name,
      eventUpgrade: eventType,
      eventName: name,
      description: description,
      status: status,
      type: transactionType,
      merchant: decrypt(localStorage.getItem("merchantcode")),
      transactionSchemaCode: decrypt(localStorage.getItem("schemaId")),
      transactionSchemaName: decrypt(localStorage.getItem("schemaName")),
      merchantId: [],
      incomingRule: {
        incomingInfixRule: tempInfixRule || [null],
        incomingPrefixRule: tempPrefixRule || [null],
      },
      querySql: sqlWhere || null,
    };
    console.log(body);
    // const token = JSON.parse(localStorage.getItem("token_gen"));
    // const res = await createEvent(token.access_token, body);
    // console.log(res, "response");
    setLoader(false);
  };

  return (
    <div>
      <Header name={"Event Management"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="dashboard__profileSettingsMain">
            <div className="dashboard__heading">
              <div className="dashboard__headingLeft">
                <div className="dashboard__headingBackLink">
                  <Link to="" onClick={() => navigate(-1)}>
                    <img src={backIcon2} alt="" />
                    <div className="dashboard__headingContent">
                      <h3>Event Management</h3>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <ValidatorForm
              className="dashboard__profileSettingsBox"
              onSubmit={onSubmit}
            >
              <div className="customForm customForm_2">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="form-group withIcon">
                      <label>Name</label>
                      <TextValidator
                        placeholder="Name"
                        className="form-control"
                        name="name"
                        onChange={onChange}
                        value={name}
                        validators={["required"]}
                        errorMessages={["Name is required"]}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="form-group withIcon">
                      <label>Event Type</label>
                      <SelectValidator
                        placeholder="Select Type"
                        className="custom-ReactSelect bordered"
                        name="eventType"
                        value={getDropdownObject(eventType, eventTypeOpt)}
                        options={eventTypeOpt}
                        onChange={(e) => onSelectChange(e, "eventType")}
                      />
                    </div>
                  </div>
                  {eventType === "Tier" || eventType === "Promotional Event" ? (
                    <></>
                  ) : (
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                      <div className="form-group withIcon">
                        <label>Transaction Type</label>
                        <SelectValidator
                          placeholder="Select Type"
                          className="custom-ReactSelect bordered"
                          name="transactionType"
                          value={getDropdownObject(
                            transactionType,
                            transTypeDisplay
                          )}
                          options={transTypeDisplay}
                          onChange={(e) => onSelectChange(e, "transactionType")}
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                    <div
                      className="person"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <p
                        className="voucher mb-2"
                        style={{
                          display: "flex",
                          width: "25%",
                          marginBottom: "0",
                          color: "black",
                        }}
                      >
                        Status
                      </p>
                      <div className="">
                        <label className="toggle">
                          <input
                            type="checkbox"
                            name="status"
                            checked={status}
                            onChange={handleToggle}
                          />
                          <span className="slider"></span>
                          <span
                            className="labels"
                            data-on="Active"
                            data-off="InActive"
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <div className="form-group withIcon">
                      <label>Description</label>
                      <TextAreaValidator
                        type="text"
                        maxLength="100"
                        value={description}
                        onChange={onChange}
                        placeholder="Description"
                        className="form-control"
                        name="description"
                      />
                    </div>
                  </div>
                  {eventType === "Tier" || eventType === "Promotional Event" ? (
                    <></>
                  ) : (
                    <div className="col-xl-12">
                      <div className="form-group withIcon">
                        <label>Rule on Incoming Data</label>
                        <QueryBuilder
                          fields={fields}
                          query={query}
                          onQueryChange={handleQueryChange}
                          controlElements={{
                            ...defaultControlElements,
                            fieldSelector: CustomFieldSelector,
                            operatorSelector: CustomOperatorSelector,
                            valueEditor: CustomValueEditor,
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 py-3">
                    <div
                      className="button-section"
                      style={{ justifyContent: "flex-end", display: "flex" }}
                    >
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ValidatorForm>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateEvent;
